import  Picto,{pictoProps, pictoState} from "./Picto";
import {connect} from "react-redux";

export interface FermerPictoProps extends pictoProps {
}

export interface FermerPictoState extends pictoState {
}

export class FermerPicto extends Picto<FermerPictoProps,FermerPictoState>{
    constructor(props) {
        super(props);
        this.picto = this.props.theme.pictos.fermerPicto;
    }
}

const mapStateToProps = (state) => {
    return {isDark: state.changeTheme.isDark,theme: state.changeTheme.theme};
}

export default connect(mapStateToProps)(FermerPicto);
